module.exports = __webpack_public_path__ + "static/media/icon-6.9fa71a03.png";